import { LuEllipsis, LuPlus } from 'react-icons/lu';
import { NavLink, useLocation } from 'react-router-dom';
import cx from 'classnames';

import { isInside } from './navItems';
import type { NavItem } from './navTypes';

interface BottomNavProps {
  items: NavItem[];
  onCreate: () => void;
  onMore: () => void;
}

/**
 * The phone's navigation, under the thumb: the day's screens either side of
 * "+", which starts anything new, and "Más" for the rest.
 */
export default function BottomNav({ items, onCreate, onMore }: BottomNavProps) {
  const { pathname } = useLocation();
  const primary = items.filter((item) => item.placement === 'primary');
  const inMore = items.some((item) => item.placement === 'more' && isInside(pathname, item.to));
  // "+" sits in the middle; the primary entries split around it.
  const half = Math.ceil(primary.length / 2);

  const tab = (item: NavItem) => (
    <NavLink key={item.to} to={item.to} end={item.to === '/'} className="v-bottomnav__item">
      <item.icon aria-hidden="true" />
      <span>{item.label}</span>
    </NavLink>
  );

  return (
    <nav
      className="v-bottomnav"
      aria-label="Navegación principal"
      style={{ gridTemplateColumns: `repeat(${primary.length + 2}, minmax(0, 1fr))` }}
    >
      {primary.slice(0, half).map(tab)}
      <button
        type="button"
        className="v-bottomnav__plus"
        onClick={onCreate}
        aria-label="Crear: nueva cita, clienta, cobro o gasto"
        aria-haspopup="dialog"
      >
        <span>
          <LuPlus aria-hidden="true" />
        </span>
      </button>
      {primary.slice(half).map(tab)}
      <button
        type="button"
        className={cx('v-bottomnav__item', { active: inMore })}
        onClick={onMore}
        aria-haspopup="dialog"
      >
        <LuEllipsis aria-hidden="true" />
        <span>Más</span>
      </button>
    </nav>
  );
}
